import React from "react";
import { View } from "react-native";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { uniqueId } from "lodash";

export default function ReportsIcon(props) {
  const width = props.width || 26;
  const height = props.height || 26;

  const filterId = "paint0_linear_reports" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";

  return (
    <View style={props.style}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.133 7.02861C16.673 7.47118 15.9414 7.45705 15.4988 6.99705L14.2016 5.64877V12.8342C14.2016 13.4726 13.6842 13.99 13.0458 13.99C12.4075 13.99 11.89 13.4726 11.89 12.8342V5.7836L10.7063 7.14994C10.2883 7.63239 9.55834 7.68466 9.07589 7.26668C8.59344 6.8487 8.54117 6.11875 8.95915 5.6363L12.1285 1.97808C12.3412 1.73263 12.6473 1.58796 12.9719 1.5795C13.2966 1.57103 13.6098 1.69953 13.835 1.93357L17.1646 5.39437C17.6072 5.85437 17.593 6.58605 17.133 7.02861ZM7.3575 12.1332C7.3575 11.4949 6.84003 10.9774 6.2017 10.9774C5.56337 10.9774 5.0459 11.4949 5.0459 12.1332V20.7999C5.0459 21.4382 5.56337 21.9557 6.2017 21.9557L6.21154 21.9556H20.0547L20.0685 21.9557C20.7068 21.9557 21.2243 21.4382 21.2243 20.7999V12.1332C21.2243 11.4949 20.7068 10.9774 20.0685 10.9774C19.4302 10.9774 18.9127 11.4949 18.9127 12.1332V19.644H7.3575V12.1332Z"
          fill={filterUrl}
        />
        <Defs>
          <LinearGradient
            id={filterId}
            x1="5.0459"
            y1="5.99812"
            x2="16.1428"
            y2="24.0008"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#05858A" />
            <Stop offset="1" stopColor="#2AE8CB" />
          </LinearGradient>
        </Defs>
      </Svg>
    </View>
  );
}
